<template>
	<div class="car_sells" :class="{'isiOSX':isiOSX}">
		<van-nav-bar v-if="isApp" title="销巴汽车" :fixed="true"/>
    	<img v-if="isApp" @click="goBack()" class="reback" src="../../assets/myInvest/reback.png">
    	<img v-if="isApp" @click="applyMerchantShare()" class="share" src="../../assets/common/xb_title_share.png">
		<van-row>
			<van-col span="24" class="banner" :style="paddT">
				<img src="../../assets/advDetail/car/car_1.png" />
				<img src="../../assets/advDetail/car/car_2.png" />
				<img src="../../assets/advDetail/car/car_3.jpg" />
				<img src="../../assets/advDetail/car/car_4.png" />
				<img src="../../assets/advDetail/car/car_5.png" />
			</van-col>
			<van-col span="24" class="footer">
				<span class="btn" @click="consultation()">申请加盟</span>
			</van-col>
			
		</van-row>
	</div>
</template>

<script>
export default {
  data() {
    return {
    	isApp: true,
      	isiOSX: false,
    	paddT: {paddingTop: '68px'} //app内
    };
  },
  created(){
  	this.isiOSX = this.isIphoneX();
  	if(this.$route.query.from) {//app外
  		this.isApp = false;
  		this.paddT = {paddingTop: '0'}
  	}else {
  		if(this.isiOSX) {//app内齐刘海
  			this.paddT = {paddingTop: '88px'}
  		}
  	}
  },
  methods: {
  	goBack() {
  		this.params('', '', 'goBack');
  	},
    consultation() {
	    this.$router.push({
          path: "/advDetail/applyFor",
          query: {
            type: this.$route.query.type
          }
        });
	},
    applyMerchantShare() {
    	this.params('', '', 'applyMerchantShare');
    }
  },
  mounted() {
  }
};
</script>

<style lang="less">
.car_sells {
	background: #A81912;
	min-height: 100%;
	.van-nav-bar {
	    height: 44px;
	    line-height: 44px;
	    padding-top: 24px;
	    box-shadow: 0 1px 0 #eee;
	    .van-nav-bar__title {
	      color: #333;
	      font-size: 17px;
	      font-weight: 700;
	    }
	}
	.reback {
	    width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    left: 0;
	    z-index: 1;
	}
	.share {
		width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    right: 0;
	    z-index: 1;
	}
	.banner{
		width: 100%;
		height: auto;
		padding-bottom: 77px;
		position: relative;
		background: #b90000;
		img{
			display: block;
			width: 100%;
			height: auto;
		}
	}
	.footer{
		background: #b90000;
		padding: 17px 12px 10px;
		height: 76px;
		width: 100%;
		position: fixed;
		left: 0;
		bottom: 0;
		z-index: 999;
		.btn{
			font-size: 18px;
			color: #b90000;
			font-weight: bold;
			height: 49px;
			line-height: 49px;
			width: 100%;
			text-align: center;
			display: inline-block;
			border-radius: 6px;
			background: -webkit-linear-gradient(#F4E09E 50%, #E1BB60 100%); /* Safari 5.1 - 6.0 */
			background: -o-linear-gradient(#F4E09E 50%, #E1BB60 100%); /* Opera 11.1 - 12.0 */
			background: -moz-linear-gradient(#F4E09E 50%, #E1BB60 100%); /* Firefox 3.6 - 15 */
			background: linear-gradient(#F4E09E 50%, #E1BB60 100%); /* 标准的语法（必须放在最后） */
		}
	}
	@media only screen and (min-width: 320px) and (max-width: 360px){
		.footer{
			padding: 12px 12px 7px;
			height: 61px;
			.btn{
				font-size: 16px;
				height: 42px;
    			line-height: 42px;
			}
		}
	}
}
.isiOSX {
	.van-nav-bar {
		padding-top: 44px;
	}
	.reback {
		top: 47px;
	}
	.share {
		top: 47px;
	}
}


</style>
